/**
 * Os desenhos ficam todos aqui.
 *
 * Um `<svg>` solto no meio de uma tela vira dez `<svg>` soltos em dez telas,
 * cada um com um traço e um tamanho diferente. Aqui é um traço só, e trocar
 * um desenho é trocar uma linha.
 *
 * Os traços em si moram no `@nosso-sempre/shared`, porque o celular desenha os
 * mesmos com `react-native-svg`. O que fica aqui é o `<svg>` do navegador.
 */

import { DESENHOS, type NomeDoIcone } from '@nosso-sempre/shared';

export type { NomeDoIcone };

interface Props {
  nome: NomeDoIcone;
  tamanho?: number;
  /** Sem rótulo o ícone é decoração e o leitor de tela o ignora. */
  rotulo?: string;
  /** Cheio em vez de contornado, que é como o coração aparece no contador. */
  preenchido?: boolean;
}

export function Icone({ nome, tamanho = 20, rotulo, preenchido }: Props) {
  return (
    <svg
      width={tamanho}
      height={tamanho}
      viewBox="0 0 24 24"
      fill={preenchido ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={preenchido ? 0 : 1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={rotulo ? 'img' : 'presentation'}
      aria-label={rotulo}
      aria-hidden={rotulo ? undefined : true}
      focusable="false"
    >
      <path d={DESENHOS[nome]} />
    </svg>
  );
}
